import type {BaseSchedule} from '@domain/schedule'
import type {AssetSnapshot} from '@hconnect/common/types'
import {dataTestId} from '@hconnect/uikit'
import {ModeCommentOutlined} from '@mui/icons-material'
import {Box, Button} from '@mui/material'
import {Moment} from 'moment-timezone'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {PLANNING_COMMENTS_WIDGET_NAMESPACE} from '../consts'
import {usePlanningComments} from '../hooks'

interface CommentSidebarButtonProps {
  toggleCommentSidebar: () => void
  schedule: BaseSchedule | undefined
  assets: AssetSnapshot[] | undefined
  startOfChart: Moment
  endOfChart: Moment
}

const _CommentSidebarButton: React.FC<CommentSidebarButtonProps> = ({
  toggleCommentSidebar,
  schedule,
  assets,
  startOfChart,
  endOfChart
}) => {
  const {t} = useTranslation(PLANNING_COMMENTS_WIDGET_NAMESPACE)
  const {comments} = usePlanningComments({
    schedule,
    assets,
    scheduleItemRange: [startOfChart, endOfChart]
  })

  return (
    <Box>
      <Button
        variant="text"
        sx={{color: 'primary.light'}}
        startIcon={<ModeCommentOutlined />}
        {...dataTestId('comments_sidebar_button')}
        onClick={toggleCommentSidebar}
      >
        {comments ? t('planning.numberOfComments', {count: comments.length}) : t('common.comments')}
      </Button>
    </Box>
  )
}

export const CommentSidebarButton = React.memo(_CommentSidebarButton)
